import type { BackupPolicyConfig } from '@repo/api-gw-sdk';
import { useState } from 'react';

import MainDialog from '@/components/dialogs/mainDialog';
import { useDAL } from '@/contexts/useDAL';

import { BackupPoliciesSelector } from '../settings/backup-policies/backupPoliciesSelector';

interface InventoryBulkPolicyAssignmentDialogProps {
  onClose: () => void;
  providerResourceIds: string[];
}

export default function InventoryBulkPolicyAssignmentDialog(
  props: InventoryBulkPolicyAssignmentDialogProps
) {
  const dal = useDAL();
  const { data: backupPolicies, isLoading } = dal.backupPolicy.list();
  const [selectedPolicies, setSelectedPolicies] = useState<
    BackupPolicyConfig[]
  >([]);
  const [updating, setUpdating] = useState(false);

  const assignToPolicy = async () => {
    try {
      setUpdating(true);

      for (const policy of selectedPolicies) {
        for (const resourceId of props.providerResourceIds) {
          if (policy.exclude?.includes(resourceId)) {
            policy.exclude = policy.exclude.filter((id) => id !== resourceId);
          }

          if (!policy.include?.includes(resourceId)) {
            policy.include = [...policy.include, resourceId];
          }
        }

        await dal.backupPolicy.update(policy);
      }
    } finally {
      props.onClose();
    }
  };

  return (
    <MainDialog
      isOpen={true}
      isLoading={isLoading}
      header={{
        title: 'Assign to backup policy',
        subtitle:
          'Choose the backup policies you want to assign the selected resources to.',
        onClose: props.onClose,
      }}
      footer={{
        primaryButton: {
          icon: 'material-symbols-bookmark-add-outline',
          text: 'Assign',
          disabled: isLoading || updating,
          onClick: () => assignToPolicy(),
          'data-testid': 'assign-to-policy-button',
        },
        secondaryButton: {
          'data-testid': 'cancel-assign-to-policy-button',
          onClick: props.onClose,
          text: 'Cancel',
        },
      }}
    >
      <BackupPoliciesSelector
        backupPolicies={backupPolicies?.backupPolicies || []}
        selectedPolicies={selectedPolicies}
        setSelectedPolicies={setSelectedPolicies}
      />
    </MainDialog>
  );
}
